// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1mN8u","content":"ManualTimeModal_content__3wtfu"};